import React, { Component } from "react";
import { Table, Button, Col, Row } from "antd";
import axios from "axios";
import PrintModal from '../components/PrintModal';
import moment from "moment-timezone"; // VALIDAR DATAS
import numeral from "numeral";
import "./Relatorios.css";

const { Column } = Table;

class CondPagtosPrintModal extends Component {
    state = {
        listaRegistros: [],
        visualizar: false,
        carregando: false,
    }

    componentDidUpdate(propsAnte, stateAnte) {
        if (!stateAnte.visualizar && this.state.visualizar) {
            this.getListaRegistros();
        }
    }

    getListaRegistros = () => {
        this.setState({ carregando: true, listaRegistros: [] });
        const { buscaDescricao } = this.props;

        axios
            .get('/condPagto', {
                params: {
                    print: true,
                    buscaDescricao: buscaDescricao
                }
            })
            .then(response => {
                const { data } = response;
                this.setState({
                    listaRegistros: data,
                    carregando: false,
                });
            })
            .catch(erro => {
                console.warn(erro);
                this.setState({
                    carregando: false,
                });
            });

    };

    onCancelar = () => {
        this.setState({
            visualizar: false
        })
    }

    onVisualizar = () => {
        this.setState({
            visualizar: true
        })
    }

    renderValor = (vlr) => {
        return (
            <span> {numeral(parseFloat(vlr)).format('0,000.00')} </span>
        );
    };

    renderPercVendas = (vlr) => {
        return (
            <span> {numeral(vlr).format('0,000.0000')} </span>
        );
    };


    renderData = (data) => {
        if (data) {
            const dataMoment = moment(data);
            return (
                <span>
                    {dataMoment.format('DD/MM/YYYY')}
                </span>
            )
        } else {
            <span></span>
        }
    }

    renderAtiva = (cp_situacao) => {
        return (
            <span>
                {cp_situacao ? 'ATIVA' : 'INATIVA'}
            </span>
        );
    };


    render() {
        const { listaRegistros, carregando, visualizar } = this.state;
        return (
            <span>
                <Button onClick={this.onVisualizar}>
                    Impressão
                </Button>

                <PrintModal
                    visible={visualizar}
                    onCancel={this.onCancelar}
                >
                    <div >
                        <div className="titulo">
                            Condições de Pagamentos
                        </div>


                        <Row style={{ marginTop: -20 }}>
                            <Table
                                pagination={false}
                                dataSource={listaRegistros}
                                className="tabela"
                                rowKey={(listaRegistros => listaRegistros.cp_idf)}
                                loading={{
                                    spinning: carregando,
                                    tip: 'Carregando. Aguarde...',
                                    size: "large"
                                }}
                            >
                                <Column
                                    key="cp_codigo"
                                    dataIndex="cp_codigo"
                                    title="Código"
                                    width={"10%"}
                                    align="center"
                                    className="listaCadastro"
                                />
                                <Column
                                    key="cp_descricao"
                                    dataIndex="cp_descricao"
                                    title="Descrição"
                                    width={"30%"}
                                    align="left"
                                    className="listaCadastro"
                                />
                                <Column
                                    key="cp_parcelas"
                                    dataIndex="cp_parcelas"
                                    title="Parcelas"
                                    width={"20%"}
                                    align="left"
                                    className="listaCadastro"
                                />
                                <Column
                                    key="cp_vlr_ped_ini"
                                    dataIndex="cp_vlr_ped_ini"
                                    title="Vlr Inicial"
                                    render={this.renderValor}
                                    width={"10%"}
                                    align="right"
                                    className="listaCadastro"
                                />
                                <Column
                                    key="cp_vlr_ped_fim"
                                    dataIndex="cp_vlr_ped_fim"
                                    title="Vlr Final"
                                    render={this.renderValor}
                                    width={"10%"}
                                    align="right"
                                    className="listaCadastro"
                                />
                                <Column
                                    key="cp_situacao"
                                    dataIndex="cp_situacao"
                                    title="Situação"
                                    render={this.renderAtiva}
                                    width={"10%"}
                                    align="center"
                                    className="listaCadastro"
                                />
                            </Table>
                        </Row>

                    </div>

                </PrintModal>
            </span>
        );
    }
}

export default CondPagtosPrintModal;



// WEBPACK FOOTER //
// ./src/relatorios/CondPagtosPrintModal.js